import * as actions from "./loss-reason.actions";
import * as selectors from "./loss-reason.selectors";

export { actions, selectors };